var render = function (_h,_vm) {var _c=_vm._c;return _c('g',[_c('rect',{attrs:{"x":"0","y":"0","width":"100%","height":"2","fill":"#008dff"}}),_c('text',{attrs:{"x":"50%","y":"0.5","font-size":"1","text-anchor":"middle","dominant-baseline":"hanging","fill":"white"}},[_vm._v("\n  GOAL!\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }